import { render, staticRenderFns } from "./DoseDistributionPanel.vue?vue&type=template&id=06bcc089&scoped=true&"
import script from "./DoseDistributionPanel.vue?vue&type=script&lang=js&"
export * from "./DoseDistributionPanel.vue?vue&type=script&lang=js&"
import style0 from "./DoseDistributionPanel.vue?vue&type=style&index=0&id=06bcc089&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bcc089",
  null
  
)

export default component.exports